const namespaced = true;

const defaultState = () => {
  return {
    loading: false,
    show: false,
    vehicle: [],
    carDetails: [],
  };
};

const state = defaultState();
const actions = {
  SET_VEHICLE({ commit }, payload) {
    commit("SET_VEHICLE", payload);
  },
};
const mutations = {
  SET_CAR_DETAILS(state, carDetails) {
    state.carDetails = carDetails;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_SHOW(state, show) {
    state.show = show;
  },
  SET_VEHICLE(state, vehicle) {
    state.vehicle = vehicle;
  },
  resetState(state) {
    Object.assign(state, defaultState());
  },
};
const getters = {
  getVehicle(state) {
    return state.vehicle;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
